import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  login,
  submitMfaVerificationToken,
  requestMfaTokenByEmail
} from '@hobs/auth/actions';
import { withTranslation } from 'react-i18next';
import LoginForm from '@hobs/auth/components/LoginForm';
import LoginTokenForm from '@hobs/auth/components/LoginTokenForm';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { getLoginImage } from '@hobs/utils/customLogoResolver';
import './Login.scss';
import { getDecodedRedirectPath } from '@hobs/utils/base64Utils/base64Utils';
import { changeCurrentExercise } from '@hobs/actions/exercises';
import Toast from '@hobs/components/Toast';
import { ENVIRONMENT_PATHS } from '@hobs/utils/constants';

class Login extends React.PureComponent {
  static propTypes = {
    login: propTypes.func,
    submitMfaVerificationToken: propTypes.func,
    requestMfaTokenByEmail: propTypes.func,
    history: propTypes.object,
    t: propTypes.func,
    match: propTypes.object,
    changeCurrentExercise: propTypes.func
  };

  state = {
    logoSrc: null,
    isValidatingMfaToken: false
  };

  async redirect() {
    const { history, match, changeCurrentExercise } = this.props;

    const redirectPath = getDecodedRedirectPath(
      this.props.match.params.redirect
    );
    if (match.params.exerciseId) {
      await changeCurrentExercise(match.params.exerciseId)
        .then(() => {
          const newPathname =
            this.getEnvironmentPathname(window.location.pathname) +
            '/' +
            redirectPath;
          return (window.location.pathname = newPathname);
        })
        .catch(() => {
          Toast.error('Cannot change current exercise');
        });
    }

    return history.push(`${redirectPath}`);
  }

  getEnvironmentPathname(windowLocationPathname) {
    const localEnvironment = '';

    for (const str of ENVIRONMENT_PATHS) {
      if (windowLocationPathname.includes(str)) {
        return str;
      }
    }

    return localEnvironment;
  }

  async submit(values) {
    const results = await this.props.login(values.username, values.password);

    if (results.success) {
      await this.redirect();
    }

    if (results.isMfaValidationNeeded) {
      this.setState({ isValidatingMfaToken: true });
    }

    return results;
  }

  async submitToken(token) {
    const results = await this.props.submitMfaVerificationToken(token);

    if (results.success) {
      await this.redirect();
    }

    return results;
  }

  async resendEmail() {
    const results = await this.props.requestMfaTokenByEmail();

    return results;
  }

  componentDidMount() {
    this.getLoginImage();
  }

  getLoginImage = () => {
    getLoginImage().then(result => {
      if (!result) {
        this.setState({
          logoSrc: require('../../assets/images/ndlo-logo.png')
        });
        return;
      }

      this.setState({ logoSrc: result });
    });
  };

  render() {
    const { t } = this.props;

    return (
      <div className="login">
        <div className="login--left">HOBS</div>
        <div className="login--right">
          <div className="login--right-top">
            {this.state.logoSrc ? (
              <img src={this.state.logoSrc} alt="" />
            ) : (
              <span />
            )}
            <img src={require('../../assets/images/wgs-logo.png')} alt="" />
          </div>
          <div className="login--right-bottom">
            <div>
              {this.state.isValidatingMfaToken ? (
                <div>
                  <div className="login--title">{t('Email login')}</div>
                  <div className="login--token-description">
                    {t(
                      'Verification code has been sent to your email. Please check your email and type in the code below.'
                    )}
                  </div>
                  <LoginTokenForm
                    translations={{
                      token: t('Verification code'),
                      login: t('Login'),
                      resendEmail: t('Resend Email'),
                      validation: {
                        tokenRequired: t('Token cannot be empty')
                      }
                    }}
                    onSubmit={this.submitToken.bind(this)}
                    onResendEmail={this.resendEmail.bind(this)}
                  />
                </div>
              ) : (
                <div>
                  <div className="login--title">{t('Login')}</div>
                  <LoginForm
                    translations={{
                      username: t('login.username'),
                      password: t('Password'),
                      login: t('Login'),
                      validation: {
                        username: t('validation.username'),
                        usernameRequired: t('Username cannot be empty'),
                        passwordRequired: t('Password cannot be empty')
                      }
                    }}
                    onSubmit={this.submit.bind(this)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    login: (username, password) => dispatch(login(username, password)),
    submitMfaVerificationToken: token =>
      dispatch(submitMfaVerificationToken(token)),
    requestMfaTokenByEmail: () => dispatch(requestMfaTokenByEmail()),
    changeCurrentExercise: id => dispatch(changeCurrentExercise(id))
  };
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(withTranslation()(Login))
);
